'use client';

import { useState } from 'react';

interface CalculatorMilesKilometersProps {}

export default function CalculatorMilesKilometers({}: CalculatorMilesKilometersProps) {
  const [miles, setMiles] = useState<string>('1');
  const [kilometers, setKilometers] = useState<string>('1.609');

  const handleMilesChange = (value: string) => {
    setMiles(value);
    const milesNum = parseFloat(value);
    if (!isNaN(milesNum)) {
      setKilometers((milesNum * 1.60934).toFixed(3));
    } else {
      setKilometers('');
    }
  };

  const handleKilometersChange = (value: string) => {
    setKilometers(value);
    const kmNum = parseFloat(value);
    if (!isNaN(kmNum)) {
      setMiles((kmNum / 1.60934).toFixed(3));
    } else {
      setMiles('');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cyan-50 via-sky-50 to-blue-50">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="text-center mb-12">
          <h1 className="text-5xl font-bold text-slate-900 mb-4">
            Miles ↔ Kilometers Converter
          </h1>
          <p className="text-lg text-slate-600">
            Convert distances between miles and kilometers instantly
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12">
          <div className="space-y-8">
            {/* Miles Input */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-3">
                Miles
              </label>
              <div className="relative">
                <input
                  type="number"
                  value={miles}
                  onChange={(e) => handleMilesChange(e.target.value)}
                  className="w-full px-6 py-4 text-2xl font-bold text-slate-900 bg-slate-50 border-2 border-slate-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-cyan-500/20 focus:border-cyan-500 transition-all"
                  placeholder="Enter miles"
                  step="0.001"
                />
                <span className="absolute right-6 top-1/2 -translate-y-1/2 text-slate-400 font-semibold">
                  mi
                </span>
              </div>
            </div>

            {/* Conversion Arrow */}
            <div className="flex justify-center">
              <div className="w-12 h-12 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-full flex items-center justify-center text-white text-2xl">
                ↕
              </div>
            </div>

            {/* Kilometers Input */}
            <div>
              <label className="block text-sm font-semibold text-slate-700 mb-3">
                Kilometers
              </label>
              <div className="relative">
                <input
                  type="number"
                  value={kilometers}
                  onChange={(e) => handleKilometersChange(e.target.value)}
                  className="w-full px-6 py-4 text-2xl font-bold text-slate-900 bg-slate-50 border-2 border-slate-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
                  placeholder="Enter kilometers"
                  step="0.001"
                />
                <span className="absolute right-6 top-1/2 -translate-y-1/2 text-slate-400 font-semibold">
                  km
                </span>
              </div>
            </div>
          </div>

          {/* Quick Reference */}
          <div className="mt-12 pt-8 border-t border-slate-200">
            <h3 className="text-lg font-bold text-slate-900 mb-4">Quick Reference</h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              <div className="bg-slate-50 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-cyan-600">1 mi</div>
                <div className="text-sm text-slate-600 mt-1">1.609 km</div>
              </div>
              <div className="bg-slate-50 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-cyan-600">5 mi</div>
                <div className="text-sm text-slate-600 mt-1">8.047 km</div>
              </div>
              <div className="bg-slate-50 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-cyan-600">10 mi</div>
                <div className="text-sm text-slate-600 mt-1">16.093 km</div>
              </div>
              <div className="bg-slate-50 rounded-lg p-4 text-center">
                <div className="text-2xl font-bold text-cyan-600">26.2 mi</div>
                <div className="text-sm text-slate-600 mt-1">42.195 km</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}